import { observer } from "mobx-react";
import PolicyStore from "../../../../../stores/policy-store";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Toggle } from "../../../../../../../components/inputs/toggle/toggle";
import Hr from "../../../../../../../components/hr/hr";

interface IProps {
    policy: PolicyStore;
}

const NotifyHelpdesk: React.FC<IProps> = observer(({ policy }) => {
    return (
        <>
            <Hr />
            <FormFieldLine
                label='Notify Helpdesk'
                note='Enable to have RMAs with this policy rule create tickets in your helpdesk system. RMAs with multiple policy rules will notify the helpdesk system if at least one of its policy rules requires it.'
            >
                <Toggle
                    onChange={policy.setNotifyHelpdesk}
                    label={""}
                    checked={policy.notifyHelpdeskEnabled}
                />
            </FormFieldLine>
        </>
    );
});

export default NotifyHelpdesk;